/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-alert */
import { useState } from "react";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
// import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
// import DefaultFooter from "examples/Footers/DefaultFooter";
// import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
// import Counters from "pages/Presentation/sections/Counters";
// import Information from "pages/Presentation/sections/Information";
// import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
// import Pages from "pages/Presentation/sections/Pages";
// import Testimonials from "pages/Presentation/sections/Testimonials";
// import Download from "pages/Presentation/sections/Download";

// Presentation page components
// import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
// import routes from "routes";
// import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-nft.jpeg";
import dodlesCoin from "assets/images/Dcoin.png";

function Presentation() {
  const [showCodeWait, setShowCodeWait] = useState(false);
  const [showTransferWait, setShowTransferWait] = useState(false);
  const [collectCode, setCollectCode] = useState("");
  const [view, setView] = useState("enterCode");
  const [inventory, setInventory] = useState([]);
  const [showNFTCollector, setShowNFTCollector] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [selectedNFTid, setSelectedNFTid] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const poolLink = () => `https://pool.pm/${walletAddress}`;

  const getAvailableNFTs = () =>
    new Promise((resolve, reject) => {
      const shuffleNFTs = (arr) => arr.sort(() => Math.random() - 0.5);
      const getNFTsURL = "http://api.getdodles.com:3030/list-nfts";
      fetch(getNFTsURL)
        .then((res) => res.json())
        .then((data) => {
          resolve(shuffleNFTs(data.nftList));
        })
        .catch((err) => {
          reject(err);
        });
    });

  const checkCollectCode = () => {
    setShowCodeWait(true);
    const checkCodeURL = `http://api.getdodles.com:3030/checkCode?code=${collectCode}`;
    fetch(checkCodeURL)
      .then((res) => res.json())
      .then((data) => {
        console.log("returned from check code: ");
        console.log(data);
        if (data.message === "valid") {
          getAvailableNFTs().then((invData) => {
            console.log(invData);
            setInventory(invData);
            setShowCodeWait(false);
            setView("showNFTSelector");
          });
        } else {
          setErrorMessage(data.message);
          setShowError(true);
        }
      });
  };

  const getNFT = (selectedNFT) => {
    setSelectedNFTid(selectedNFT);
    setShowNFTCollector(true);
  };

  const transferNFT = () => {
    setShowTransferWait(true);
    const transferURL = `http://api.getdodles.com:3030/transfernft?userCode=${collectCode}&userWallet=${walletAddress}&nftID=${selectedNFTid}`;
    fetch(transferURL).then((data) => {
      if (!data.error) {
        setShowTransferWait(false);
        setShowNFTCollector(false);
        setView("NFTsent");
      } else {
        alert(`there was an error processing Your transfer: ${data.message}`);
        setShowTransferWait(false);
        setShowNFTCollector(false);
        setView("NFTnotsent");
      }
    });
  };

  const handleClose = () => {
    setShowNFTCollector(false);
  };

  const closeError = () => {
    setErrorMessage("");
    setShowCodeWait(false);
    setShowError(false);
  };

  const handleInput = (event) => {
    setCollectCode(event.target.value);
  };

  const handleWalletInput = (event) => {
    setWalletAddress(event.target.value);
  };

  const displayInventoryGrid = () => {
    // eslint-disable-next-line prefer-const
    let gridDisplay = [];
    if (inventory.length === 0) {
      gridDisplay.push(
        <Grid item xs={12}>
          <MKTypography variant="h2">No NFTs available.</MKTypography>
        </Grid>
      );
    } else {
      for (let i = 0; i < inventory.length; i++) {
        gridDisplay.push(
          <Grid item xs={4} key={i}>
            <MKBox
              color="white"
              bgColor="dark"
              borderRadius="lg"
              shadow="lg"
              opacity={1}
              p={3}
              sx={{ alignItems: "center" }}
              onClick={() => {
                getNFT(inventory[i]);
              }}
            >
              <img alt="" src={dodlesCoin} width="80%" />
            </MKBox>
          </Grid>
        );
      }
    }
    return gridDisplay;
  };
  return (
    <>
      <MKBox
        minHeight="70vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "",
          display: "grid",
          placeItems: "center",
        }}
      />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Dialog open={showError} onClose={closeError}>
          <DialogTitle>Something went wrong</DialogTitle>
          <DialogContentText>{errorMessage}</DialogContentText>
          <DialogActions>
            <Button onClick={closeError}>OK</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={showNFTCollector} onClose={handleClose}>
          <DialogTitle>Collect your NFT</DialogTitle>
          {showTransferWait ? (
            <DialogContent>
              <DialogContentText>
                Your NFT transfer is being processed. This may take a while.
              </DialogContentText>
              <CircularProgress color="dark" />
            </DialogContent>
          ) : (
            <>
              <DialogContent>
                <DialogContentText>Enter your Cardano wallet receive address</DialogContentText>
                <MKInput
                  label="enter your wallet address..."
                  onChange={handleWalletInput}
                  value={walletAddress}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={transferNFT}>Submit</Button>
              </DialogActions>
            </>
          )}
        </Dialog>
        <Container>
          {view === "enterCode" && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MKTypography variant="h2">Collect your dodles coin drop NFT</MKTypography>
              </Grid>
              <Grid item xs={4}>
                <MKInput label="enter your code..." onChange={handleInput} value={collectCode} />
              </Grid>
              <Grid item xs={4}>
                {showCodeWait ? (
                  <CircularProgress color="dark" />
                ) : (
                  <MKButton variant="text" color="dark" onClick={() => checkCollectCode()}>
                    Submit
                  </MKButton>
                )}
              </Grid>
              <Grid item xs={4}>
                &nbsp;
              </Grid>
            </Grid>
          )}
          {view === "showNFTSelector" && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MKTypography variant="h2">Select Your NFT</MKTypography>
              </Grid>
              {displayInventoryGrid()}
            </Grid>
          )}
          {view === "NFTsent" && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MKTypography variant="h2">Your NFT is on its way</MKTypography>
              </Grid>
              <Grid item xs={12}>
                <MKTypography variant="body1">
                  The NFT has been submited to the block chain. You should see it in you wallet in a
                  few minutes.
                </MKTypography>
                <MKTypography variant="body1">
                  Once your NFT has completed its transfer you should be able to see it here:{" "}
                  <a href={poolLink()} target="_blank" rel="noreferrer">
                    pool.pm
                  </a>
                </MKTypography>
              </Grid>
            </Grid>
          )}
          {view === "NFTnotsent" && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MKTypography variant="h2">There was a problem processing your NFT</MKTypography>
              </Grid>
              <Grid item xs={12}>
                <MKTypography variant="body1">Your NFT was nte sent to your wallet</MKTypography>
              </Grid>
            </Grid>
          )}
        </Container>
      </Card>
    </>
  );
}

export default Presentation;

/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
